import React from 'react';
import { Box, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../theme/tokens';

/**
 * SkipNavigation Component
 * 
 * Provides skip links for keyboard users to bypass repetitive navigation
 * and jump directly to main content or other key sections.
 * 
 * Requirements: 8.7 - Skip navigation links for keyboard users
 */
export const SkipNavigation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="nav"
      aria-label={t('common.skipNavigation')}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: tokens.zIndex.tooltip,
      }}
    >
      <Link
        href="#main-content"
        sx={{
          position: 'absolute',
          left: '-9999px',
          top: 'auto',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
          '&:focus': {
            position: 'fixed',
            top: tokens.spacing.sm,
            left: tokens.spacing.sm,
            width: 'auto',
            height: 'auto',
            padding: `${tokens.spacing.sm}px ${tokens.spacing.md}px`,
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            textDecoration: 'none',
            borderRadius: tokens.borderRadius.md,
            boxShadow: tokens.shadows.lg,
            zIndex: tokens.zIndex.tooltip,
            outline: `3px solid`,
            outlineColor: 'primary.dark',
            outlineOffset: '2px',
          },
        }}
      >
        {t('common.skipToMainContent')}
      </Link>
      <Link
        href="#navigation"
        sx={{
          position: 'absolute',
          left: '-9999px',
          top: 'auto',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
          '&:focus': {
            position: 'fixed',
            top: tokens.spacing.sm,
            left: `calc(${tokens.spacing.sm}px + 200px)`,
            width: 'auto',
            height: 'auto',
            padding: `${tokens.spacing.sm}px ${tokens.spacing.md}px`,
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            textDecoration: 'none',
            borderRadius: tokens.borderRadius.md,
            boxShadow: tokens.shadows.lg,
            zIndex: tokens.zIndex.tooltip,
            outline: `3px solid`,
            outlineColor: 'primary.dark',
            outlineOffset: '2px',
          },
        }}
      >
        {t('common.skipToNavigation')}
      </Link>
    </Box>
  );
};
